












import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'ldw-icontext'
})

export default class IconTextComponent extends Vue {
    // properties
    @Prop(String) private readonly icon: string | undefined
    @Prop(String) private readonly headline: string | undefined
    @Prop(String) private readonly text: string | undefined
    // data
    // methods
}
